import { render, staticRenderFns } from "./ImportarJ4_TIH.vue?vue&type=template&id=c3833eee&scoped=true"
import script from "./ImportarJ4_TIH.vue?vue&type=script&lang=js"
export * from "./ImportarJ4_TIH.vue?vue&type=script&lang=js"
import style0 from "./ImportarJ4_TIH.vue?vue&type=style&index=0&id=c3833eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3833eee",
  null
  
)

export default component.exports